import React from 'react'
import { Grid } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import MainTemplate from '../../templates/MainTemplate'
import Filters from '../../containers/product/filters/Index'
import TopProductSales from '../../containers/product/charts/TopProductSales'
import ProductTable from '../../components/ProductTableState'
import ProductTableWeek from '../../components/ProductTableWeek'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2)
    }
  })
)

const Index = (): JSX.Element => {
  const classes = useStyles()

  return (
    <MainTemplate>
      <div className={classes.container}>
        <Filters />
      </div>
      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <TopProductSales />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <ProductTable />
        </Grid>
      </Grid>

      <Grid item container spacing={1} className={classes.container}>
        <Grid item xs={12}>
          <ProductTableWeek />
        </Grid>
      </Grid>
    </MainTemplate>
  )
}

export default Index
